<template>
  <NuxtLink
    :is="buttonOrNuxtLink"
    v-bind="to ? { to: to } : {}"
    :target="$useTarget(to, target)"
    class="group flex max-w-text items-start gap-3 text-base transition-colors hover:text-blue-800"
  >
    <ExternalLinkIcon
      v-if="$isExternalUrl(to)"
      class="mt-[0.2em] w-5 shrink-0 text-blue-800"
    />
    <ArrowGrowIcon v-else class="mt-[0.375em] w-6 shrink-0 text-blue-800" />
    <slot />
  </NuxtLink>
</template>

<script setup>
const props = defineProps({
  to: { type: [String, Object], default: null },
  target: { type: String, default: null },
})

// determine whether to load NuxtLink or button
const buttonOrNuxtLink = computed(() => {
  if (props.to) {
    return resolveComponent('NuxtLink')
  }

  return 'button'
})
</script>
